var ko = require('knockout'),
  AUTHORIZATION_TYPE = require('_js/constants/authorization'),
  HOURS_TYPE = require('_js/constants/hours'),
  filter = require('lodash/filter');
require('knockout-postbox');

function CalculatorYear(params) {
  this.hasLeave = params.data.Leave;
  this.year = ko.observable(params.data.Year);

  this.yearLength = params.yearLength;
  this.typeDisplay = ko.observable('done');
  this.excludeTimeunits = params.excludeTimeunits;
  this.currentYear = new Date().getFullYear();

  var startAuth = window.authorizedAccountant
    ? AUTHORIZATION_TYPE.ACCOUNTANT
    : AUTHORIZATION_TYPE.AUDITOR;
  this.AuthorizationType = ko
    .observable(startAuth)
    .subscribeTo('authorizationType', true);
  this.MAX_HOURS = ko.observable(80).subscribeTo('hoursRequirement', true);
  this.hoursDone = ko.observable(params.data.TotalStructuredHoursDone);
  this.unstructuredHoursDone = ko.observable(
    params.data.TotalUnstructuredHoursDone
  );
  this.hoursPlanned = ko.observable(params.data.TotalHoursPlanned);
  this.hoursShopping = ko.observable(0);

  // If the year displayed is equal to the current year we should get the total hours done and planned
  // for the period and calculate how many hours are missing and must be completed within the year.
  if (this.year() >= this.currentYear) {
    this.totalHoursDone = ko
      .observable(params.data.TotalHoursDone)
      .subscribeTo('totalHoursDone', true);
    this.totalUnstructuredHoursDone = ko
      .observable(params.data.TotalUnstructuredHoursDone)
      .subscribeTo('totalUnstructuredHoursDone', true);
    this.totalHoursPlanned = ko
      .observable(params.data.TotalHoursPlanned)
      .subscribeTo('totalHoursPlanned', true);
    this.hoursMissing = ko.computed(function() {
      var val =
        this.MAX_HOURS() -
        this.totalHoursDone() -
        this.totalHoursPlanned() -
        this.hoursShopping();
      if (val < 0) {
        val = 0;
      }
      return val;
    }, this);
  } else {
    this.hoursMissing = ko.computed(function() {
      return 0;
    });
  }

  // An object that is passed to timeunits component.
  this.hours = ko.computed(function() {
    return {
      done: params.data.TotalStructuredHoursDone,
      doneUnstructured: params.data.TotalUnstructuredHoursDone,
      planned: params.data.TotalHoursPlanned,
      shopping: this.hoursShopping(),
      required: this.MAX_HOURS(),
      missing: this.hoursMissing()
    };
  }, this);

  this.totalHours = ko.observable(params.data.TotalStructuredHoursDone);
  this.totalUnstructuredHours = ko.observable(
    params.data.TotalUnstructuredHoursDone
  );
  this.hoursDisplay = ko.observable(this.hoursDone());

  // Listen to updates in the shopping cart.
  ko.postbox.subscribe(
    'shoppingCartUpdated',
    function(newCart) {
      var courses = newCart.courses;
      if (courses.length > 0) {
        this.setHoursShopping(courses);
      } else {
        this.hoursShopping(0);
      }
    },
    this,
    true
  );

  // Listen to which hour type we should display.
  ko.postbox.subscribe(
    'showHoursType',
    function(type) {
      if (type === HOURS_TYPE.EMPTY) {
        this.hoursDisplay(this.hoursMissing());
        this.typeDisplay('remaining');
      } else if (type === HOURS_TYPE.PLANNED) {
        this.hoursDisplay(this.hoursPlanned());
        this.typeDisplay('progress');
      } else if (type === HOURS_TYPE.SHOPPING) {
        this.hoursDisplay(this.hoursShopping());
        this.typeDisplay('shopping');
      } else {
        this.hoursDisplay(this.hoursDone());
        this.typeDisplay('done');
      }
    },
    this,
    true
  );

  // Listen to changes in the hours.
  ko.postbox.subscribe(
    'hoursDone',
    function(newValue) {
      this.hoursDone(this.addHoursForYear(newValue, this.hoursDone()));
    },
    this,
    true
  );
  ko.postbox.subscribe(
    'hoursPlanned',
    function(newValue) {
      this.hoursPlanned(this.addHoursForYear(newValue, this.hoursPlanned()));
    },
    this,
    true
  );
  ko.postbox.subscribe(
    'hoursShopping',
    function(newValue) {
      this.hoursShopping(this.addHoursForYear(newValue, this.hoursShopping()));
    },
    this,
    true
  );
  ko.postbox.subscribe(
    'hoursRequirement',
    function(newValue) {
      this.MAX_HOURS(this.addHoursForYear(newValue, this.MAX_HOURS()));
    },
    this,
    true
  );
}

CalculatorYear.prototype.addHoursForYear = function(data, oldValue) {
  // If the data is for this year we can use the hours specified by data.
  if (data.year === this.year()) {
    return data.hours;
  }
  // If not, we should stick with the value we already have.
  else {
    return oldValue;
  }
};

CalculatorYear.prototype.setHoursShopping = function(courses) {
  // var multiplier = add ? 1 : -1;
  var hours = 0;
  courses.forEach(
    function(course) {
      var year;
      // Check if date is defined. If it is not, we'll just set it to the current year.
      if (course.Date === undefined || course.Date === null) {
        year = new Date().getFullYear();
      } else {
        year = new Date(course.Date).getFullYear();
      }
      // We only want to update this component if the course year is equal to this year.
      if (year === this.year()) {
        var filteredCredits = filter(course.AuthorizationCredits, {
          AuthorizationType: this.AuthorizationType()
        });
        filteredCredits.forEach(
          function(credit) {
            hours += parseFloat(credit.Hours, 10);
          }.bind(this)
        );
      }
    }.bind(this)
  );

  this.hoursShopping(hours);
};

CalculatorYear.prototype.triggerInfoPopup = function() {
  ko.postbox.publish('openPopup', {
    modalTitle: 'Permisjon',
    modalText:
      'Tekst om permisjon og hvordan jeg legger til og fjerner/endrer år. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis ut massa cursus, lacinia risus ut, pellentesque odio. Duis dapibus ante non nisl faucibus posuere.'
  });
};

module.exports = CalculatorYear;
